export { default as Confirmation } from './confirmation';
export { default as Critical } from './critical';
export { default as Information } from './information';
export { default as Warning } from './warning';



// WEBPACK FOOTER //
// ./src/icon/svgs/feedback/index.js